import { createSelector } from '@ngrx/store';

import { Association } from '@shared/models';

import { CollectionsState, getCollectionsState } from '../collections.reducer';
import { associationsAdapter } from './associations.reducer';

export const getAssociationsState = createSelector(
  getCollectionsState,
  (state: CollectionsState) => !!state && state.associations,
);

export const {
  selectIds: getAssociationsIds,
  selectEntities: getAssociationsEntities,
  selectAll: getAssociationsAll,
  selectTotal: getAssociationsTotal,
} = associationsAdapter.getSelectors(getAssociationsState);

export const AssociationsSelectorObj = {
  getJobAssociations: (jobId: number) =>
    createSelector(
      getAssociationsAll,
      (entities) => !!entities && entities.filter((association) => association.reqId === jobId),
    ),
};

export const checkAssociationByCandidateIdAndJobId = (candidateId, jobId) => (association) =>
  association.candidateId === candidateId && association.reqId === jobId;

export const AssociationByCandidateIdJobIdObj = {
  getAssociationByCandidateIdAndJobId: (candidateId, jobId) =>
    createSelector(getAssociationsAll, (entities: Association[]) => {
      let existingAssociation: Association;
      if (!!entities) {
        existingAssociation = entities.find(
          checkAssociationByCandidateIdAndJobId(candidateId, jobId),
        );
      }
      return existingAssociation ? existingAssociation : null;
    }),
};

export const checkIfBatchRejectForShortlistedIsAvailable = (candidateIds, jobId) =>
  createSelector(getAssociationsAll, (associations) => {
    let isRejectingAvailable = true;
    if (candidateIds.length > 1) {
      let tempAssociation = associations.find(
        checkAssociationByCandidateIdAndJobId(candidateIds[0], jobId),
      );
      candidateIds.map((candidateId) => {
        const association = associations.find(
          checkAssociationByCandidateIdAndJobId(candidateId, jobId),
        );
        isRejectingAvailable =
          isRejectingAvailable && tempAssociation.status === association.status;
        tempAssociation = association;
      });
    }

    return isRejectingAvailable;
  });
export const getAssociationsByCandidatesIdsAndJobId = createSelector(
  getAssociationsAll,
  (
    associations: Association[],
    { candidateIds, jobId }: { candidateIds: number[]; jobId: number },
  ) => {
    let existingAssociations: Association[];
    if (!!associations) {
      existingAssociations = candidateIds.map((candidateId) => {
        const association = associations.find(
          checkAssociationByCandidateIdAndJobId(candidateId, jobId),
        );

        return !!association ? association : new Association(candidateId, jobId);
      });
    }
    return existingAssociations ? existingAssociations : [];
  },
);

export const getAssociationCandidateIds = createSelector(getAssociationsAll, (entities) =>
  entities.map(({ candidateId }) => candidateId),
);

export const getAssociation = (id) =>
  createSelector(getAssociationsEntities, (entities) => !!entities && entities[id]);
